// extracted by mini-css-extract-plugin
export var arrows = "_75-5";
export var decrementer = "_75-9";
export var disabled = "_75-3";
export var error = "_75-1";
export var hiddenText = "_75-a";
export var incrementer = "_75-8";
export var input = "_75-7";
export var inputWrapper = "_75-0";
export var leadingIcon = "_75-b";
export var readonly = "_75-2";
export var regular = "_75-6";
export var small = "_75-4";